import React, { Component } from 'react';
const ReactHighstock = require('react-highcharts/ReactHighstock');

export class DurationGraph extends Component {
    render() {
        const series = this.props.series || [];
        const config = {
            credits: { enabled: false },
            legend: {
                enabled: true,
                align: 'right',
                borderColor: 'black',
                borderWidth: 1,
                itemDistance: 25,
                layout: 'vertical',
                verticalAlign: 'top',
                y: 100,
                shadow: true
            },
            chart: {
                zoomType: 'xy'
            },
            rangeSelector: {
                selected: 4
            },
            title: {
                text: this.props.name || 'DurationGraph'
            },
            plotOptions: {
                series: {
                    showInNavigator: true
                },
                connectNulls: true
            },
            series
        };

        const durationChart = <ReactHighstock config={config} ref="chart" />
        return (
            <div>
                {durationChart}
            </div>
        );
    }
}

export default DurationGraph;